import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
  headerBGColor: "#ffffff", // 顶部背景颜色
  activeColor: "#409EFF", // 菜单栏选中文字颜色,按钮背景/边框颜色等
  activeBGColor: "rgba(64,158,255,.08)", // 菜单栏选中文字颜色,按钮背景/边框颜色等
  deleteColor: "#eb4d64", // 菜单栏选中文字颜色,按钮背景/边框颜色等
  deleteBGColor: "rgba(242,74,98,.08)", // 菜单栏选中文字颜色,按钮背景/边框颜色等
  noticeColor: "#ea0722",// 通知颜色
  size:10000,// 返回所有数据
  breadList:[{name:"HousingManagementFullRent",cName:"整租房源",path:"/HousingManagementFullRent"}], // 面包屑列表
  editableTabsValue:"HousingManagementFullRent", // 默认选中tab
  activeValue:"0-0", // 菜单栏默认选中
  editableTabs: [{
    title: '整租房源', // tabs页的名称
    index:'0-0', // tabs页的选中
    name: 'HousingManagementFullRent', // tabs页的英文名称
    path: '/HousingManagementFullRent', // tabs页的地址
    closable:false // 是否可以关闭，false是不可以，true是可以关闭
  }],
  defaultList: [ // 菜单栏
    { groupItem: '房源管理', index: '0', icon: 'el-icon-s-home',children: [
      { navItem: '整租房源',icon: 'el-icon-s-flag', index: '0-0', name: 'HousingManagementFullRent', path:'/HousingManagementFullRent' },
      { navItem: '学生公寓',icon: 'el-icon-s-finance', index: '0-1', name: 'HousingManagementSchool', path:'/HousingManagementSchool' },
      { navItem: '短租房源',icon: 'el-icon-s-claim', index: '0-2', name: 'HousingManagementShortLease', path:'/HousingManagementShortLease' },
      ]
    },
    { groupItem: '咨询记录', index: '1', icon: 'el-icon-s-goods', name: 'ConsultationRecord', path:'/ConsultationRecord' },
    { groupItem: '用户管理', index: '2', icon: 'el-icon-s-grid', name: 'UserManagement', path:'/UserManagement' },
    { groupItem: '平台优惠管理', index: '3', icon: 'el-icon-s-data', name: 'PlatformDiscountManagement', path:'/PlatformDiscountManagement' },
    { groupItem: '房源排序管理', index: '4', icon: 'el-icon-star-on', name: 'ListingSortingManagement', path:'/ListingSortingManagement' },
    { groupItem: '城市管理', index: '5', icon: 'el-icon-s-marketing', name: 'UrbanManagement', path:'/UrbanManagement' },
    { groupItem: '学校管理', index: '6', icon: 'el-icon-menu', name: 'SchoolManagement', path:'/SchoolManagement' },
    { groupItem: '区域管理', index: '7', icon: 'el-icon-s-open', name: 'RegionalManagement', path:'/RegionalManagement' },
    { groupItem: '地标管理', index: '8', icon: 'el-icon-s-unfold', name: 'LocationManagement', path:'/LocationManagement' },
    { groupItem: '标签管理', index: '9', icon: 'el-icon-tickets', name: 'LabelManagement', path:'/LabelManagement' },
    { groupItem: '费用明细管理', index: '10', icon: 'el-icon-sell', name: 'CostManagement', path:'/CostManagement' },
    { groupItem: '房屋信息管理', index: '11', icon: 'el-icon-box', name: 'HousingInformationManagement', path:'/HousingInformationManagement' },
    { groupItem: '设施管理', index: '12', icon: 'el-icon-platform-eleme', name: 'FacilitiesManagement', path:'/FacilitiesManagement' },
    { groupItem: 'Banner管理', index: '13', icon: 'el-icon-picture',name: 'BannerManagement', path:'/BannerManagement' },
    { groupItem: '顾问微信二维码管理', index: '14', icon: 'el-icon-s-release', name: 'WeChatManagement', path:'/WeChatManagement' },
    { groupItem: '管理员管理', index: '15', icon: 'el-icon-s-custom', name: 'administratorsManagement', path:'/administratorsManagement' },
    { groupItem: '安家服务', index: '16', icon: 'el-icon-office-building', name: 'RelocationServiceManagement', path:'/RelocationServiceManagement' }
  ],
  memberId:0,//所选用户
  userList:[],//未读消息用户列表
  unreadNumber:0,//未读消息数量
}

//修改数据仓库的事件
const mutations = {
  // 监听 editableTabsValue
  changeEditableTabsValue(state,value){
    state.editableTabsValue = value;
  },
  // 监听 breadList
  changeBreadList(state,value){
    state.breadList = value;
  },
  // 关闭 tableTabs
  changeSetEditableTabs(state,value){
    state.editableTabs = value;
  },
  // 关闭 activeValue
  changeActiveValue(state,value){
    state.activeValue = value;
  },
  // 修改 未读消息用户列表
  changeUserListValue(state,value){
    state.userList = value;
  },
  // 修改 未读消息数量
  changeUnreadNumberValue(state,value){
    state.unreadNumber = value;
  },
  // 修改 所选用户
  changeMemberIdValue(state,value){
    state.memberId = value;
  }
}

//推荐使用的异步修改数据仓库
const actions =  {
  setEditableTabsValue(context,value){
    context.commit('changeEditableTabsValue',value)
  },
  setBreadList(context,value){
    let array = [{name:"HousingManagementFullRent",cName:"整租房源",path:"/HousingManagementFullRent"}];
    if (state.editableTabsValue != "HousingManagementFullRent"){
      state.defaultList.forEach(function(item){
        if (item.children != undefined){
          item.children.forEach(function(child){
            if (child.name == state.editableTabsValue){
              array.push({cName:item.groupItem,name:"",path:""});
              array.push({cName:child.navItem,name:child.name,path:child.path})
            }
          })
        } else {
          if (item.name == state.editableTabsValue){
            array.push({cName:item.groupItem,name:item.name,path:item.path})
          }
        }
      })
    }
    value = array;
    context.commit('changeBreadList',value)
  },
  setCloseTab(context,value){
    let tabs = state.editableTabs;
    let activeName = state.editableTabsValue;
    if (activeName === value) {
      tabs.forEach((tab, index) => {
        if (tab.name === value) {
          let nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            activeName = nextTab.name;
          }
        }
      });
    }
    state.editableTabsValue = activeName;
    context.commit('changeSetEditableTabs',tabs.filter(tab => tab.name !== value))
  },
  setCloseAllTabs(context,value){
    state.editableTabs =  [{
      title: '整租房源',//tabs页的名称
      index:'0-0',//tabs页的选中
      name: 'HousingManagementFullRent',//tabs页的英文名称
      path: '/HousingManagementFullRent',//tabs页的地址
      closable:false// 是否可以关闭，false是不可以，true是可以关闭
    }];
    value = state.editableTabs;
    context.commit('changeSetEditableTabs',value)
  },
  setPushCloseAllTabs(context,value){
    state.editableTabs.push(value);
    context.commit('changeSetEditableTabs',state.editableTabs)
  },
  setActiveValue(context,value){
    context.commit('changeActiveValue',value)
  },
  setUserListValue(context,value){
    context.commit('changeUserListValue',value)
  },
  setUnreadNumberValue(context,value){
    context.commit('changeUnreadNumberValue',value)
  },
  setMemberIdValue(context,value){
    context.commit('changeMemberIdValue',value)
  }
}

// 下面这个相当关键了，所有模块，注册才能使用
export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js